import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../services/api';
import toast from 'react-hot-toast';

export const sendOTP = createAsyncThunk('auth/sendOTP', async (mobile, { rejectWithValue }) => {
  try { return await api.post('/auth/send-otp', { mobile }); }
  catch (e) {
    const msg = e.response?.data?.message || 'Failed to send OTP';
    const registered = e.response?.data?.registered;
    if (registered === false) {
      // Don't show toast for not-registered — handled in UI
      return rejectWithValue(msg);
    }
    return rejectWithValue(msg);
  }
});

export const verifyOTP = createAsyncThunk('auth/verifyOTP', async (data, { rejectWithValue }) => {
  try { return await api.post('/auth/verify-otp', data); }
  catch (e) { return rejectWithValue(e.response?.data?.message); }
});

export const employeeLogin = createAsyncThunk('auth/employeeLogin', async (data, { rejectWithValue }) => {
  try { return await api.post('/auth/employee-login', data); }
  catch (e) { return rejectWithValue(e.response?.data?.message); }
});

export const fetchProfile = createAsyncThunk('auth/profile', async () => {
  return await api.get('/auth/profile');
});

const initialState = {
  token: localStorage.getItem('noc_token'),
  user: JSON.parse(localStorage.getItem('noc_user') || 'null'),
  role: localStorage.getItem('noc_role'),
  loading: false,
  otpSent: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state) => {
      state.token = null; state.user = null; state.role = null; state.otpSent = false;
      localStorage.clear();
    },
    setOtpSent: (state, action) => { state.otpSent = action.payload; }
  },
  extraReducers: (builder) => {
    builder
      .addCase(verifyOTP.fulfilled, (state, { payload }) => {
        state.token = payload.token; state.user = payload.user; state.role = payload.role;
        localStorage.setItem('noc_token', payload.token);
        localStorage.setItem('noc_user', JSON.stringify(payload.user));
        localStorage.setItem('noc_role', payload.role);
        toast.success('Login successful!');
      })
      .addCase(employeeLogin.fulfilled, (state, { payload }) => {
        state.token = payload.token; state.user = payload.user; state.role = payload.role;
        localStorage.setItem('noc_token', payload.token);
        localStorage.setItem('noc_user', JSON.stringify(payload.user));
        localStorage.setItem('noc_role', payload.role);
        toast.success('Login successful!');
      })
      .addCase(sendOTP.fulfilled, (state) => { state.otpSent = true; toast.success('OTP sent to your mobile!'); })
      .addCase(sendOTP.rejected, (state, { payload }) => {
        // Only show toast for non-registration errors
        if (payload && !payload.includes('not registered')) {
          toast.error(payload || 'Failed to send OTP');
        }
      })
      .addCase(fetchProfile.fulfilled, (state, { payload }) => { state.user = payload.user; })
      .addMatcher(action => action.type.endsWith('/pending'), state => { state.loading = true; })
      .addMatcher(action => action.type.endsWith('/fulfilled') || action.type.endsWith('/rejected'), state => { state.loading = false; });
  }
});

export const { logout, setOtpSent } = authSlice.actions;
export default authSlice.reducer;